/* istanbul ignore file */
import isEmpty from 'lodash/isEmpty';
export const notEmpty = (v) => !isEmpty(v);
//# sourceMappingURL=notEmpty.js.map